// src/pages/AnalyticsPage.js
import React, { useState } from 'react';
import DashboardLayout from "../../components/test/DashboardLayout";
import AnalyticsFilterBar from "../../components/analytics/AnalyticsFilterBar";
import AnalyticsKPICards from "../../components/analytics/AnalyticsKPICards";
import LoyaltyGrowthChart from "../../components/analytics/LoyaltyGrowthChart";
import PointsFlowChart from "../../components/analytics/PointsFlowChart";
import RedemptionRateChart from "../../components/analytics/RedemptionRateChart";
import CustomerTierDistributionChart from "../../components/analytics/CustomerTieDistributionChart";
import {useParams} from "react-router-dom";

const AnalyticsPage = () => {
    const {userId, businessId} = useParams();

    const [dateRange, setDateRange] = useState('Last 30 Days'); // e.g., 'Last 7 Days', 'Last 30 Days', 'This Month', 'This Year', 'Custom'
    const [selectedProgram, setSelectedProgram] = useState('All Programs'); // e.g., 'All Programs', 'Standard Points Program', 'VIP Tier Rewards'
    const [granularity, setGranularity] = useState('Monthly'); // e.g., 'Daily', 'Weekly', 'Monthly'

    // Mock list of available loyalty programs
    const availablePrograms = ['All Programs', 'Standard Points Program', 'VIP Tier Rewards', 'Seasonal Spend & Save'];
    const availableGranularities = ['Daily', 'Weekly', 'Monthly']; // Granularity options

    return (
        <DashboardLayout userId={userId} businessId={businessId}>
            <h1 className="text-3xl font-bold text-gray-800 mb-6">Analytics & Reports</h1>

            {/* Filter Bar */}
            <AnalyticsFilterBar
                dateRange={dateRange}
                setDateRange={setDateRange}
                selectedProgram={selectedProgram}
                setSelectedProgram={setSelectedProgram}
                availablePrograms={availablePrograms}
                granularity={granularity}
                setGranularity={setGranularity}
                availableGranularities={availableGranularities}
            />

            {/* KPI Cards */}
            <AnalyticsKPICards dateRange={dateRange} selectedProgram={selectedProgram} />

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-8">
                {/* Loyalty Program Growth Chart */}
                <LoyaltyGrowthChart dateRange={dateRange} selectedProgram={selectedProgram} granularity={granularity} />

                {/* Points Issued vs. Redeemed Chart */}
                <PointsFlowChart dateRange={dateRange} selectedProgram={selectedProgram} granularity={granularity} />

                {/* Redemption Rate Trend Chart */}
                <RedemptionRateChart dateRange={dateRange} selectedProgram={selectedProgram} granularity={granularity} />

                {/* Customer Tier/Points Distribution Chart */}
                <CustomerTierDistributionChart dateRange={dateRange} selectedProgram={selectedProgram} />
            </div>
        </DashboardLayout>
    );
};

export default AnalyticsPage;